const $inject = ['$scope'];
const lbFiveStarRatingController = function ($scope) {
  let vm = this;
  vm.wholeStars = Math.trunc(vm.rating);
  vm.starThatNeedsHalfStar = Math.ceil(vm.rating) > vm.wholeStars ? Math.ceil(vm.rating) : 0;

  vm.shouldBeWholeStar = function (whichStar) {
    return vm.wholeStars >= whichStar;
  };

  vm.shouldBeHalfStar = function (whichStar) {
    return vm.starThatNeedsHalfStar == whichStar;
  };

  vm.shouldBeEmptyStar = function (whichStar) {
    return vm.wholeStars < whichStar && vm.starThatNeedsHalfStar != whichStar;
  };
};

lbFiveStarRatingController.$inject = $inject;

export default lbFiveStarRatingController;



// WEBPACK FOOTER //
// ./src/components/lbFiveStarRating/lbFiveStarRatingController.js